import { FormInputMeta } from '@Modules/core/types/FormMetaType';
import commonFormMeta from '@Shared/components/form/commonFormMeta';
import { capitalize } from '@Shared/utils/helpers';
import { getValidationSchema } from '@Shared/utils/validationSchema';
import * as yup from "yup";


export interface IRechargeFeesFormMeta {
    idBank: FormInputMeta;
    nameBank: FormInputMeta;
    idFees: FormInputMeta;
    nameFees: FormInputMeta;
    static: FormInputMeta;
    rate: FormInputMeta;
    min: FormInputMeta;
    max: FormInputMeta;
    
    schema: any;
  }

const RechargeFeesFormMeta = {} as IRechargeFeesFormMeta;

RechargeFeesFormMeta.idBank = {
    name: "idBank",
    label: "ID Banque",
    type: "text",
    validation: yup.string().required("Ce champ est requis"),
}
RechargeFeesFormMeta.nameBank = {
    name: "nameBank",
    label: "Raison Sociale",
    type: "text",
    validation: yup.string().required("Ce champ est requis"),
}
RechargeFeesFormMeta.idFees = {
    name: "idFees",
    label: "ID Frais",
    type: "text",
    validation: yup.string().required("Ce champ est requis"),
}
RechargeFeesFormMeta.nameFees = {
    name: "nameFees",
    label: "Nom Frais",
    type: "text",
    validation: yup.string().required("Ce champ est requis"),
}
RechargeFeesFormMeta.static = {
    name: "static",
    label: "Fixe",
    type: "number",
    validation: yup.string().required("Ce champ est requis"),
}
RechargeFeesFormMeta.rate = {
    name: "rate",
    label: "Taux",
    type: "number",
    validation: yup.string().required("Ce champ est requis"),
}
RechargeFeesFormMeta.min = {
    name: "min",
    label: "Minimum",
    type: "number",
    validation: yup.string().required("Ce champ est requis"),
}
RechargeFeesFormMeta.max = {
    name: "max",
    label: "Maximum",
    type: "number",
    validation: yup.string().required("Ce champ est requis"),
}


RechargeFeesFormMeta.schema = yup.object().shape(getValidationSchema(RechargeFeesFormMeta));

export default RechargeFeesFormMeta;